import "./styles/App.css";
import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { ScrollTop } from "./components/ScrollTop";
import { publicRoutes, authRoutes, protectedRoutes, NotFound } from "./routes/routeConfig";
import Private from "./components/auth/ProtectedRoute";
import LoadingSpinner from "./components/common/LoadingSpinner";
import RecaptchaWrapper from "./RecaptchaWrapper";
import ScrollToTopButton from "./components/common/ScrollToTopButton";
import { ChatbotLauncher } from "./chatbot/ChatbotLauncher";
const App = () => {
    return (
        <>
            {/* <ScrollTop /> */}
            <ChatbotLauncher/>
            <ScrollToTopButton />
            <Suspense fallback={<LoadingSpinner />}>
                <Routes>
                    {/* Public Routes */}
                    {publicRoutes.map(({ path, element: Element }, index) => (
                        <Route
                            key={`public-${path}-${index}`}
                            path={path}
                            element={<Element />}
                        />
                    ))}

                    {/* Auth Routes */}
                    {authRoutes.map(({ path, element: Element, isLoginPage }, index) => (
                        <Route
                            key={`auth-${path}-${index}`}
                            path={path}
                            element={ <RecaptchaWrapper><Private Component={Element} isLoginPage={isLoginPage} /></RecaptchaWrapper>}
                        />
                    ))}


                    {/* Protected Routes */}
                    {protectedRoutes.map(({ path, element: Element }, index) => (
                        <Route
                            key={`protected-${path}-${index}`}
                            path={path}
                            element={<Private Component={Element} />}
                        />
                    ))}
                    {/* 404 Route */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
        </>
    );
};

export default App;
